export default __webpack_public_path__ + "static/hero-85c1fff8a6dfeaca16dcd52b836f716d.jpg";